export default {
  particle: {
    color: '#ffffff',
    particleOpacity: 0.5,
    particlesNumber: 80,
    shapeType: 'circle',
    particleSize: 3,
    linesColor: '#ffffff',
    linesWidth: 1,
    lineLinked: true,
    lineOpacity: 0.4,
    linesDistance: 150,
    moveSpeed: 6,
    hoverEffect: true,
    hoverMode: 'grab',
    clickEffect: false,
    clickMode: 'push',
    backgroundColor: '#555555',
  },
  bubble: {
    color: '#1b1e34',
    particleOpacity: 0.3,
    particlesNumber: 6,
    shapeType: 'polygon',
    particleSize: 160,
    linesColor: '#ffffff',
    linesWidth: 2,
    lineLinked: false,
    lineOpacity: 1,
    linesDistance: 200,
    moveSpeed: 8,
    hoverEffect: false,
    hoverMode: 'grab',
    clickEffect: false,
    clickMode: 'push',
    backgroundColor: '#2c2e43',
  },
  star: {
    color: '#ffffff',
    particleOpacity: 1,
    particlesNumber: 160,
    shapeType: 'circle',
    particleSize: 3,
    linesColor: '#ffffff',
    linesWidth: 1,
    lineLinked: false,
    lineOpacity: 0.4,
    linesDistance: 150,
    moveSpeed: 1,
    hoverEffect: false,
    hoverMode: 'bubble',
    clickEffect: false,
    clickMode: 'repulse',
    backgroundColor: '#232741',
  },
  gradient: [
    ['#EE7752', '#E73C7E', '#23A6D5', '#23D5AB'],
    ['#ffb68a', '#ff9ed3', '#29c4ff'],
    ['#5fd1f9', '#5558da'],
    ['#ff9472', '#f2709c'],
    ['#b6f492', '#338b93'],
    ['#dab9fc', '#7d59fc'],
  ],
};



// WEBPACK FOOTER //
// ./src/views/dashboard/data/background-option.js